import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PontotelSeletor = _resolveComponent("PontotelSeletor")!

  return (_openBlock(), _createBlock(_component_PontotelSeletor, _mergeProps($setup.propriedades, {
    "model-value": $setup.estado,
    "carregar-itens": null,
    "selecao-multipla": $props.selecaoMultipla,
    desabilitado: $props.desabilitado,
    "modo-exibicao": $props.somenteLeitura,
    "permite-selecionar-todos": $props.permiteSelecionarTodos,
    "habilitar-duplo-clique": $props.habilitarDuploClique,
    "recarregar-todos": !$props.somenteLeitura,
    "recarregando-todos": $setup.catalogo.atualizando.value,
    "onUpdate:modelValue": $setup.alterarSelecao,
    onFiltrandoItens: _cache[0] || (_cache[0] = ($event: any) => ($setup.emit('filtrando-itens', $event))),
    onDuploClique: $setup.tratarDuploClique,
    "onUpdate:selecionouTodos": _cache[1] || (_cache[1] = ($event: any) => ($setup.emit('update:selecionouTodos', $event))),
    onRecarregarTodos: $setup.catalogo.atualizar
  }), null, 16 /* FULL_PROPS */, ["model-value", "selecao-multipla", "desabilitado", "modo-exibicao", "permite-selecionar-todos", "habilitar-duplo-clique", "recarregar-todos", "recarregando-todos", "onRecarregarTodos"]))
}